import * as React from 'react';
import ReactDOM from 'react-dom';
import { PortalApp } from './PortalApp'
import { Layout } from './Layout'
import { App } from './App';
import { OrderApp } from './OrderApp';

declare global {
    interface Window {
        startPortal: any;
        startOrdering: any
    }
}


window.startPortal=(element: string)=> {
    const rootElement = document.getElementById(element);
    ReactDOM.render(<App>
        <Layout>
            <PortalApp />
        </Layout>
    </App>, rootElement);
}

window.startOrdering = (element: string, minHeight: string | number) => {
    const rootElement = document.getElementById(element);
    ReactDOM.render(
        <App minHeight={minHeight}><OrderApp /></App>
    , rootElement);
}


 